import { useEffect, useMemo } from "react";
import { ReadableContent } from "./ReadableContent";
import {
  getReadableContent,
  removeReadableContent,
} from "./readableContentStore";

export interface ReadableContentWindowProps {
  contentId: string;
}

/** Full-height reader surface for the ``readable-content`` utility window. */
export function ReadableContentWindow({ contentId }: ReadableContentWindowProps) {
  const stored = useMemo(() => getReadableContent(contentId), [contentId]);

  useEffect(() => {
    return () => {
      removeReadableContent(contentId);
    };
  }, [contentId]);

  if (!stored) {
    return (
      <div
        className="flex h-full items-center justify-center p-6 text-sm text-slate-400"
        data-testid="readable-content-missing"
      >
        Content is no longer available in this session.
      </div>
    );
  }

  return (
    <div
      className="flex h-full min-h-0 flex-col overflow-hidden bg-slate-950 text-slate-100"
      data-testid="readable-content-window"
    >
      <div className="min-h-0 w-full flex-1 overflow-auto px-3 py-3 sm:px-4">
        <ReadableContent node={stored.content} variant="window" />
      </div>
    </div>
  );
}
